import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export interface UserHomePayload {
    address: string;
    latitude: number;
    longitude: number;
    radiusM?: number;
}

export interface UserHomeResponse {
    address: string;
    latitude: number;
    longitude: number;
    radiusM: number;
}

export class UserHomeRepository {
    // 집주소 조회
    static onGetHome = () => {
        return onRequest({
            url: getApiUrl('userHome'),
            method: RequestMethod.GET,
        });
    }

    // 집주소 저장/수정
    static onSaveHome = (payload: UserHomePayload) => {
        return onRequest({
            url: getApiUrl('userHome'),
            method: RequestMethod.PUT,
            params: payload,
        });
    }
}
